import { Navigate } from 'react-router-dom';

const JKLU = () => {
  return <Navigate to='/signup/jklu' />;
};

export default JKLU;
